import { Link } from 'react-router-dom'
import { useHomeDashboard } from '@/api/queries'
import { StatusChip } from '@/components/ui/status-chip'
import type { WidgetSpan } from '../Widget'
import { Widget } from '../Widget'

/**
 * Synthetic multi-service journeys have NO backing /admin/v2 endpoint yet
 * (FR-CAT-02) — so this widget renders an honest "not wired yet" gap rather
 * than fabricated pass/fail rows (data-truth rule #2). It goes live the AWU a
 * real journeys-svc reader ships.
 */
export function JourneysBoardWidget({ span = 8 }: { span?: WidgetSpan }) {
  const { data } = useHomeDashboard()

  return (
    <Widget
      title={<>Journeys board</>}
      badges={
        <>
          <StatusChip status="info">FR-CAT-02</StatusChip>
          <StatusChip status="unknown" stale>
            not wired yet
          </StatusChip>
        </>
      }
      provenance={data?.provenance.journeys}
      span={span}
      footer={
        <Link to="/fleet#journeys" className="font-semibold text-accent hover:underline">
          Open full journeys board →
        </Link>
      }
    >
      <div className="py-4 text-[12.5px] text-ink-2">
        Synthetic end-to-end journey probes prove infra works across services — not per-service pings. No journeys-svc
        endpoint exists in <span className="mono">/admin/v2</span> yet, so this board stays an honest, empty placeholder
        rather than showing fabricated runs.
      </div>
    </Widget>
  )
}
